import RcTabs from 'rc-tabs'
import PropTypes from 'prop-types'

import TabPane from './TabPane'

const Tabs = ({ defaultActiveKey, onChange, children, color, className }) => {
  const classNameTabs =
    `tabs tabs_color_${color}` + (className ? ` ${className}` : '')

  return (
    <RcTabs
      defaultActiveKey={defaultActiveKey}
      onChange={onChange}
      className={classNameTabs}
    >
      {children}
    </RcTabs>
  )
}

Tabs.TabPane = TabPane

Tabs.propTypes = {
  defaultActiveKey: PropTypes.string,
  onChange: PropTypes.func,
  children: PropTypes.any,
  color: PropTypes.oneOf(['primary', 'secondary']),
}

export { TabPane }
export default Tabs
